import { isAllowedReturnUrl } from '@words-happen/app-urls';

/** The browser history and location the identity screens read and leave by. Injectable so it can be tested. */
export interface BrowserNavigation {
  /** document.referrer: the page the player arrived from, or '' when unknown. */
  referrer: () => string;
  /** history.length: the entries in this tab's session history. */
  historyLength: () => number;
  back: () => void;
  /** A full page navigation, out of the identity app. */
  assign: (url: string) => void;
  /** A full page navigation that replaces this page's history entry, so back skips it. */
  replace: (url: string) => void;
}

export const windowNavigation: BrowserNavigation = {
  referrer: () => document.referrer,
  historyLength: () => window.history.length,
  back: () => window.history.back(),
  assign: (url) => window.location.assign(url),
  replace: (url) => window.location.replace(url),
};

/**
 * The identity screens' back chevron: back through history when the player came from an allowed origin and has
 * history to go back to, otherwise on to `fallbackUrl`.
 */
export const goBack = (navigation: BrowserNavigation, allowedOrigins: readonly string[], fallbackUrl: string): void => {
  if (isAllowedReturnUrl(navigation.referrer(), allowedOrigins) && navigation.historyLength() > 1) {
    navigation.back();
  } else {
    navigation.assign(fallbackUrl);
  }
};
